export const formatValueToServerData = (values) => ({
  invitees_limit: values.inviteesLimit,
})
